import { graphql } from '@api/generated';

import { getClient } from '../../../api/client';

const getCurrentServicesQuery = graphql(`
  query currentServices {
    contactCenters {
      items {
        id
        name
      }
    }
  }
`);

async function getCurrentServices() {
  const { data, error } = await getClient().query({
    query: getCurrentServicesQuery,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.contactCenters?.items ?? [];
}

export default getCurrentServices;
